module.exports = __webpack_public_path__ + "static/img/404.793e71d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = zAji
// module chunks = 0